import { Control, Controller, useController } from 'react-hook-form'
import React from 'react'

import { FormData } from '../../ChallengeAdmin'
import YumField from '../../../../components/YumInput/YumInput'
import InputAdornment from '@material-ui/core/InputAdornment'
import { red } from '../../../../styles/material-ui-theme-v2'

interface ChallengePointsUnitFieldProps {
  control: Control<FormData, any>
  name: any
  label: string
  error: any
  disabled?: boolean
  unit?: string
  max?: number
  isDistance?: boolean
}

export default function ChallengePointsAmountField(props: ChallengePointsUnitFieldProps) {
  const { control, name, max, label, unit, error, disabled, isDistance } = props
  const {
    field: { onChange, name: controllerName, value, ref },
  } = useController({
    control,
    name,
  })

  // const min = isDistance ? 0.25 : 1
  const min = 1
  const errorStyle: any = { position: 'relative', top: '-10px', color: red, fontSize: '11px' }

  return (
    <>
      <Controller
        name={controllerName}
        rules={{
          min,
          max,
          required: true,
        }}
        control={control}
        render={({ field: { ref, ...otherField } }) => (
          <YumField
            shrink
            label={label}
            type="number"
            inputProps={{ inputMode: 'numeric' }}
            disabled={disabled}
            inputRef={ref}
            error={error}
            onWheel={(e: { target: { blur: () => any } }) => e.target.blur()}
            InputProps={
              unit && {
                endAdornment: (
                  <InputAdornment style={{ flexShrink: 0, pointerEvents: 'none' }} position="end" disableTypography>
                    {unit}
                  </InputAdornment>
                ),
              }
            }
            {...otherField}
          />
        )}
      />
      {error && error.type === 'min' && <div style={errorStyle}>Min = {min}</div>}
      {error && error.type === 'max' && <div style={errorStyle}>Max = {max}</div>}
    </>
  )
}
